export class CompactListItem<T = any> {
    id: string | number;
    type: string;
    selected: boolean;
    highlighted: boolean;
    semiHighlighted: boolean;
    criticalHighlighted: boolean;
    muted: boolean;
    properties: {} = {};
    object: T;

    constructor(obj = null) {
        if (obj) {
            Object.assign(this, obj);
        }
    }
}